import styled, { css } from 'styled-components'

import theme from 'theme_'
import { H1 } from 'components/Typography/Headings'

export const EventSpan = styled.span`
  color: ${theme.colors.otterWarmBlack};
  font-weight: 700;
`

export const MessageCenterWrapper = styled.div`
  margin-top: 32px;
`

export const MessageCenterHeader = styled(H1)`
  margin-bottom: 16px;
`

export const MessageCenterSearchWrapper = styled.div`
  margin-bottom: 16px;
`

export const LightSpan = styled.span`
  color: ${theme.colors.moreGrey};
`

export const ConsumersWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const MessageCenterRowStyle = css`
  height: auto;
`
